const ENV = process.env.REACT_APP_ENV || ''
let clientID = '0oaxte31b5XjibNi8697'
if (ENV?.toLocaleLowerCase() === 'prod') {
  clientID = '0oaxte8hwsz5VMWBo697'
}

export const oktaConfig = {
  clientId: clientID,
  issuer: 'https://helpathome.okta.com',
  redirectUri: `${window.location.origin}/login/callback`,
  scopes: ['openid', 'email', 'groups', 'profile'],
  pkce: true
}
